<template>
  <!-- 天美贷我要还款页面 -->
  <div class="page tmd-overdue-repayment">
    <navigation class="navigation">逾期还款</navigation>
    <div class="wapper">
      <div class="repayment-info">

        <div class="card-description">
          <span>逾期总额 (元)</span>
        </div>

        <div class="card-amount">
          {{ totalRepaymentAmount | currency }}
        </div>
      </div>
    </div>
    <div class="repayment-schedule">
      <table width="100%">
        <tr class="table-header">
          <th width="10%"></th>
          <th width="30%">还款日</th>
          <th width="30%">期数</th>
          <th width="30%">应还金额(元)</th>
        </tr>
                
        <tr class="table-row" v-for="(item, index) in overdueList" :key="index" @click="selectTerm(item.repaymentIndex, item)">
          <td>
            <div :class="['select', selectedTerm.includes(item.repaymentIndex) && 'selected', !item.termCanRepay && 'disabled' ]"></div>
          </td>
          <td>{{ item.repaymentDueDate | date('YYYY/MM/DD') }}</td>
          <td>{{ item.repaymentIndex }}/{{ scheduleList.length }}期</td>
          <td class="amount">
            <div class="amount-wrapper">
              <span>{{ item.repaymentDueTotal | currency }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="footer">
      <nd-button class="btn" @click="goRepayment" :disabled="selectedTerm.length === 0">{{ repayBtnText }}</nd-button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'tmd-overdue-repayment',
  data: function () {
    return {
      query: this.$route.query || {},
      totalRepaymentAmount: 5000,
      creditStartTime: Date.now(),
      loanPlatform: this.$route.query.loanPlatform,
      agreementUrl: '',
      fundCode: 'WUJIE',
      productCd: this.$route.query.productCd,
      orderId: this.$route.query.orderId,
      scheduleList: [],
      canRepay: true,
      canOffLineRepay: false,
      onLineRepayInProcess: false, // 当前订单是否在线上还款中（true 线上还款中）
      offLineRepayInProcess: false, // 当前订单是否在处于线上还款中（true 线下还款中）
      dueDate: '',
      termNo: '',
      popItem: {}, 
      overdueVisible: false,
      selectedTerm: [], // 选中的列表存的是期号
      overDueTerm: [], // 所有的逾期期号
      overdueList: [], 
      sub: 0 // 表示期号和需要的差值
    }
  }, 
  async created () {
    await this.getOrderDetail()
    this.$bus.$emit('ready')
  },
  filters: {
    status (value) {
      const mapping = {
        U: '待还',
        O: '已逾期',
        S: '已还',
        J: '还款中',
        R: '对账中'
      }
      return mapping[value]
    }
  }, 
        
  methods: {
    ...mapActions('order', ['getOrderDetailX']),
    ...mapActions('repay', ['getRepayTrialX']),

    getRepayTrial () {
      const params = {
        loanPlatform: this.loanPlatform,
        orderId: this.orderId,
        terms: this.selectedTerm.map(item => {
          return {
            termNo: this.overdueList[this.convertToSeqNo(item)].repaymentIndex,
            overdays: this.overdueList[this.convertToSeqNo(item)].overdueDays
          }
        }),
        fundCode: this.fundCode
      }
      return this.getRepayTrialX(params)
    },
  
    async getOrderDetail () {
      const response = await this.getOrderDetailX(this.query)
      if (response.success === true) {
        this.totalRepaymentAmount = response.data.totalRepaymentAmount
        this.creditStartTime = response.data.creditStartTime
        this.loanPlatform = response.data.loanPlatform
        this.agreementUrl = response.data.agreementUrl
        this.fundCode = response.data.fundCode
        this.scheduleList = response.data.terms
        this.canOffLineRepay = response.data.canOffLineRepay
        this.canRepay = response.data.canRepay
        this.offLineRepayInProcess = response.data.offLineRepayInProcess
        this.onLineRepayInProcess = response.data.onLineRepayInProcess
        this.dueDate = response.data.dueDate
        this.termNo = response.data.termNo
                    
        this.overdueList = this.scheduleList.filter(item => item.termStatus === 'O')
        this.canRepayList = this.scheduleList.filter(item => item.termCanRepay && item.termStatus === 'O')

        // 默认选择逾期期数
        this.selectedTerm = []
        this.overdueList.forEach((item, idx) => item.termCanRepay && this.selectedTerm.push(item.repaymentIndex) && this.overDueTerm.push(item.repaymentIndex))
        if (this.overdueList.length > 0) {
          this.sub = this.overdueList[0].repaymentIndex - 0 // 这里计算出第一个期号和需要的差值
        }
        // 计算当前逾期还款金额
        this.totalRepaymentAmount = this.overdueList.reduce((a, b) => (a + b.repaymentDueTotal), 0.0)
      }
    },

    async goRepayment () {
      this.$report({
        id: 10101
      })
      this.$storage.set(
        'selectedTerms',
        this.overdueList.filter(item => this.selectedTerm.includes(item.repaymentIndex))
      )
      const response = await this.getRepayTrial()
      if (response.success) {
        this.$storage.set('trail', response.data)
        this.$router.push({
          path: '/repayment/confirm/tmd',
          query: {
            orderId: this.orderId,
            loanPlatform: this.loanPlatform,
            fundCode: this.fundCode, 
            productCd: this.productCd, 
            canOffLineRepay: this.canOffLineRepay ? 'T' : 'F'
          }
        })
      }
    }, 

    // 选择期数 index 表示的是期数
    selectTerm (index, term) {
      // 如果当期不可选，直接返回
      if (!term.termCanRepay) return
      const canList = []
      this.overdueList.map((item, idx) => {
        if (!this.selectedTerm.includes(idx) && item.termCanRepay) {
          canList.push(item.repaymentIndex)
        }
      })
      // canOnlyRepayAll 'true' 代表只能提前结清
      if (this.selectedTerm.includes(index)) { // 取消勾选
        if (Math.max(...this.selectedTerm) === index) { // 最后一个取消勾选
          this.toggle(this.selectedTerm, index)
        } else {
          this.selectedTerm = this.slice(this.selectedTerm, 0, this.convertToSeqNo(index))
          this.$message('请先归还较早逾期账单')
        }
      } else { // 勾选
        if (this.selectedTerm.length === 0) { // 什么都没选
          if (this.convertToSeqNo(index) === 0) { // 选第一个
            this.toggle(this.selectedTerm, index)
          } else {
            this.selectedTerm = this.slice(this.overDueTerm, 0, this.convertToSeqNo(index) + 1)
            this.$message('请先归还较早逾期账单')
          }
        } else {
          let max = Math.max(...this.selectedTerm)
          if (index - max > 1) {
            this.selectedTerm = this.slice(this.overDueTerm, 0, this.convertToSeqNo(index) + 1)
            this.$message('请先归还较早逾期账单')
          } else {
            this.toggle(this.selectedTerm, index)
          }
        }
      }
    },

    convertToSeqNo (repaymentIndex) { // 将期号转换成序号
      return repaymentIndex - this.sub
    },

    slice (arr, start, end) {
      arr = arr.slice(start, end)
      return arr
    },

    toggle (arr, i) {
      const index = arr.indexOf(i)
      if (index === -1) {
        arr.push(i)
      } else {
        arr.splice(index, 1)
      }
      return arr
    } 

    // platform (type) {
    //     const map = {
    //         'YZD': {
    //             name: '聚美颜值贷' 
    //         }, 
    //         'LFQ': {
    //             name: '领分期' 
    //         },
    //         'TM': {
    //             name: '天美贷'
    //         }
    //     }
    //     return map[type]
    // }
  },
  computed: {
    repayBtnText () {
      if (this.selectedTerm.length > 0) {
        return `去还款：${this.formatMoney(this.totalAmount)} (元)`
      } else {
        return '去还款'
      }
    },

    totalAmount () {
      let total = 0
      for (let i = 0; i < this.selectedTerm.length; i++) {
        const item = this.selectedTerm[i]
        total += this.overdueList[this.convertToSeqNo(item)].repaymentDueTotal
      }
      return total
      // return this.selectedTerm.reduce((a, b) => a + this.scheduleList[this.convertToSeqNo(b)].repaymentDueTotal, 0)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .tmd-overdue-repayment {
        background-color: #fafafa;
        padding-bottom: 210px;
        .navigation {
            border-bottom: 2px #fafafa solid;
        }

        .wapper {
            background: #ffffff;
            padding-bottom: 46px;
            padding-top: 10px;
            margin: 0 auto;
            .repayment-info {
                background: rgba(255, 51, 51, 0.03);
                margin: 30px 40px 10px 40px;
                padding: 40px 30px;
                border-radius: 20px;
                box-sizing: border-box;
                
                .card-description {
                    margin-top: 21px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: rgba(51,51,51,1);
                    line-height: 40px;
                    text-align: center;
                }

                .card-amount {
                    margin-top: 9px;
                    font-size: 72px;
                    font-family: DIN-Medium,DIN;
                    font-weight: 500;
                    color: rgba(255,52,70,1);
                    line-height: 87px;
                    text-align: center;
                }
            }
        }

        .repayment-schedule {
            background-color: white;
            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 27px;
                        height: 50px;
                        line-height: 50px;
                        padding-top: 7px;
                        padding-bottom: 7px;
                        border-bottom: 1.5px solid @iuc;
                        font-family: PingFangSC-Regular,PingFang SC;
                        font-weight: 400;
                    }
                }

                .table-row {
                    td {
                        height: 110px;
                        line-height: 110px;
                        font-size: 26px;
                        text-align: center;
                        font-family: PingFangSC-Regular,PingFang SC;
                        font-weight: 400;

                        .select {
                            margin-left: 40px;
                            width: 32px;
                            height: 32px;
                            background-size: cover;
                            background-image: url(../../assets/images/icon_unselected.png);

                            &.selected {
                                background-image: url(../../assets/images/icon_selected.png);
                            }

                            &.disabled {
                                background-image: none;
                                background-color: #DDDDDD;
                                border-radius: 32px;
                            }
                        }
                    }

                    .status {
                        &.o {
                            color: @fc-error;
                        }
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }

                    .amount {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;

                        .amount-wrapper {
                            position: relative;
                        }
                        
                    }
                }
            }
        }

        .footer {
            width: 750px;
            margin-left: -375px;
            height: 180px;
            background-color: #FFF;
            position: fixed;
            bottom: 0;
            left: 50%;

            .btn {
                margin: 0 auto;
                margin-top: 28px;
            }
        }

        .overdue-repayemnt-info, .prepay-rule {
            padding: 0 45px;
            padding-bottom: 37px;

            .title {
                height: 72px;
                line-height: 72px;
                font-size: 42px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
            }

            .divide {
                height: 32px;
                line-height: 32px;
                font-size: 28px;
                margin-top: 23px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
            }

            .amount {
                font-size: 32px;
                height: 32px;
                line-height: 32px;
                margin-top: 27px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                color: @fc1;

                &.overdue {
                    color: @theme;
                }

                em {
                    font-size: 22px;
                    padding-left: 10px;
                    display: inline-block;
                    font-style: normal;
                    font-family: PingFangSC-Medium,PingFang SC;
                    font-weight: 500;
                    color: @fc4;
                    text-decoration: line-through;
                }
            }

            .explain {
                font-size: 22px;
                height: 44px;
                line-height: 44px;
                margin-top: 3px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc4;
                text-align: left;
            }

            .principal,.interest {
                margin-top: 15px;
                height: 40px;
                line-height: 40px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
            }

            p {
                font-size: 24px;
                line-height: 33px;
                margin-top: 30px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
            }
        }
    }
</style>